import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_add_integration",
  ref: "addIntegrationModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_integration_header"
}
const _hoisted_5 = {
  key: 0,
  class: "fw-bolder"
}
const _hoisted_6 = {
  key: 1,
  class: "fw-bolder"
}
const _hoisted_7 = {
  id: "kt_modal_add_integration_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_10 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_integration_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_integration_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_integration_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_11 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Third Party")
], -1)
const _hoisted_13 = { class: "fv-row mb-7" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "User", -1)
const _hoisted_15 = { class: "fv-row mb-7" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Password", -1)
const _hoisted_17 = {
  key: 0,
  class: "fv-row mb-7"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Cookie", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("b", null, "Instructions to get the cookies file:", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Install in your Google Chrome the extension "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://chrome.google.com/webstore/detail/get-cookiestxt-locally/cclelndahbckbenkjhflpdbgdldlbecc",
      target: "_blank"
    }, "Get cookies.txt LOCALLY"),
    /*#__PURE__*/_createTextVNode(" and make sure "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "chrome://extensions/?id=cclelndahbckbenkjhflpdbgdldlbecc",
      target: "_blank"
    }, "it's available in Incognito/Private Mode"),
    /*#__PURE__*/_createTextVNode(" and pin it so it always appears on the bar. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Open a new Incognito/Private window and log in to the console."),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Click on the "),
    /*#__PURE__*/_createElementVNode("i", null, "Get cookies.txt LOCALLY"),
    /*#__PURE__*/_createTextVNode(" extension button, select "),
    /*#__PURE__*/_createElementVNode("b", null, "JSON format"),
    /*#__PURE__*/_createTextVNode(" and click "),
    /*#__PURE__*/_createElementVNode("b", null, "Export all cookies"),
    /*#__PURE__*/_createTextVNode(" button")
  ])
], -1)
const _hoisted_22 = { class: "modal-footer flex-center" }
const _hoisted_23 = ["data-kt-indicator"]
const _hoisted_24 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_26 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_27 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.formData.id == 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "Add Integration"))
            : (_openBlock(), _createElementBlock("h2", _hoisted_6, "Edit Integration: " + _toDisplayString(_ctx.formData.user), 1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.thirdparty_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.thirdparty_id) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdparties, (thirdparty) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: thirdparty.id,
                          label: thirdparty.name,
                          value: thirdparty.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_el_form_item, { prop: "user" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.user,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.user) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_form_item, { prop: "password" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.password,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event)),
                        type: "password",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.formData.thirdparty_id == 1 || _ctx.formData.thirdparty_id == 6 || _ctx.formData.thirdparty_id == 7 || _ctx.formData.thirdparty_id == 8)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_el_form_item, { prop: "cookie" }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "file",
                            ref: "fileRef",
                            name: "cookie",
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChangeFile && _ctx.onChangeFile(...args))),
                            accept: ".json"
                          }, null, 544)
                        ]),
                        _: 1
                      }),
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("span", _hoisted_26, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_30))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_23)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}